<script lang="ts">
  import { untrack, onMount } from "svelte"
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"
  import ActionBox from "@kontextwerk/web-sdk/ui/layout/ActionBox.svelte"
  import { escapeHtml } from "@kontextwerk/web-sdk/core/security"
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import type { InboxWorkflowRowEditorProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import type { ContactPointReviewRow, ContactPointReviewDraft } from "../../contract"
  import { ContactComparisonTag } from "../../../../../../_shared/_modules/contact-comparison-tag"
  import { comparison, validateDraft } from "../../_shared/_logic/comparison"
  let {
    row,
    draft,
    disabled,
    save,
    onshowOverlay,
    setActionButtonSnippet,
  }: InboxWorkflowRowEditorProps<ContactPointReviewRow, ContactPointReviewDraft> = $props()
  let value = $state(untrack(() => draft.value ?? row.submittedContactValue))
  let error = $state<string | null>(null)
  const saveDraft = () => {
    error = validateDraft(row, { ...draft, value })

    if (!error) error = save({ value: value.trim() })
  }
  onMount(() => {
    const registerActions = setActionButtonSnippet
    registerActions?.(footerSnippet)
    onshowOverlay?.()

    return () => registerActions?.(null)
  })
</script>
{#snippet footerSnippet()}
  <div class="editor-actions">
  <CTA
      type="primaryButton"
      content="Speichern"
      darkMode={false}
      {disabled}
      onclick={saveDraft}
      tooltipContent="Speichert den Entwurf in dieser Zeile. Übernommen wird er anschließend mit der Batch-Aktion."
    />
  </div>
{/snippet}

<div class="editor-content form light">
  <ContactComparisonTag value={comparison(row, draft, true)} />
  <section class="editor-fields" aria-label="Neues Kontaktdatum">
  <ActionBox label="Neues Kontaktdatum" darkMode={false}>
  <div class="form light"
        ><div class="row single">
  <Input
            label={`Neues Kontaktdatum (${row.contactPointKindLabel})`}
            type={row.contactPointKind === "EMAIL" ? "email" : "tel"}
            bind:value
            surfaceTone="light"
            brightBackground={true}
            {disabled}
            required={true}
            style="width: 100%; min-width: 0;"
            tooltip={escapeHtml(
              `Vom Kunden genannt: ${row.submittedContactValue || "Nicht genannt"} · Herkunft: ${row.sourceLabel}`,
            )}
          />
  </div></div
      >
  </ActionBox>
  </section>
  {#if error}<p role="alert" class="editor-error">{error}</p>{/if}
</div>
<style>
  .editor-actions {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    min-width: 0;
  }
  .editor-content {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    width: 100%;
    gap: 1.25rem;
    min-width: 0;
    color: var(--text-invers-100);
  }
  .editor-fields {
    width: 100%;
    min-width: 0;
  }
  .editor-fields :global(.box) {
    width: 100%;
    min-width: 0;
    height: auto;
    box-sizing: border-box;
    border-color: color-mix(in srgb, var(--text-invers-100) 25%, transparent);
  }
  .editor-error {
    margin: 0;
    color: var(--error-100, #b42318);
  }
</style>
